import React, {useContext, useEffect, useState} from 'react'
import {Divider, DatePicker, Form, Input, Row, Col, Button, AutoComplete} from "antd";
import OfferCreateMaterial from "./OfferCreateMaterials";
import {OfferContext} from "../../../context/OfferContext";
import {createOffer} from "../../../services/serviceOffer";
import moment from "moment";
import {getRelevantPersonByCustomer} from "../../../services/serviceRelevantPerson";
import {getWithWarehouseInventories} from "../../../services/serviceStock";
import {exitLoadingState, enterLoadingState} from "../../../utils/helpers/commonFunctions";

const dateFormat = 'DD/MM/YYYY'
const {Option} = AutoComplete

const OfferCreate = ({customerList}) => {
    const [form] = Form.useForm()
    const {subTotal, offerInformation, materialInformation, stocks} = useContext(OfferContext)
    const [offerInfo, setOfferInfo] = offerInformation
    const [, setStockList] = stocks
    const [materials] = materialInformation
    const [customers, setCustomers] = useState([])
    const [relevants, setRelevants] = useState([])
    const [loadings, setLoadings] = useState([])


    useEffect(() => {
        getWithWarehouseInventories()
            .then(({data}) => {
                let stockData = []
                data.forEach(item => {
                    let inventoryText = ''
                    item.inventoryList.map(inventory => {
                        inventoryText = inventoryText + `${inventory.warehouse.name} - ${inventory.quantity},`
                    })
                    let stockItem = {
                        text: `${item.stock.code} - ${item.stock.name} ( ${inventoryText} )`,
                        value: item.stock.id
                    }
                    stockData.push(stockItem)
                })
                setStockList(stockData)
            })
        form.setFieldsValue({
            offerDate: moment(new Date(), dateFormat)
        })

    }, [])

    useEffect(() => {
        if (customerList) {
            let customerData = []
            customerList.forEach(item => {
                let customer = {
                    text: item.name,
                    value: item.id
                }
                customerData.push(customer)
            })
            setCustomers(customerData)
        }

    }, [customerList])

    const handleCustomerChange = (val, option) => {
        form.setFieldsValue({
            offerCompanyOfficer: ''
        })

        if (option.key) {
            getRelevantPersonByCustomer(option.key)
                .then(({data}) => {
                    let relevantData = []
                    data.forEach(item => {
                        let pushObj = {
                            value: item.id,
                            text: `${item.name} ${item.surname}`
                        }
                        relevantData.push(pushObj)
                    })
                    setRelevants(relevantData)
                })
            let mockContext = Object.assign({}, offerInfo)
            mockContext.customer = option.key
            setOfferInfo(mockContext)
        }
    }

    const handleSubmit = () => {
        enterLoadingState(setLoadings)

        const {
            offerCompanyOfficer,
            offerDate,
            offerShipping,
            offerPayment,
            offerNote,
            offerCurrency
        } = form.getFieldsValue()

        let contentOfBidList = []
        Object.keys(materials).map(key => {
            let item = materials[key]

            if(item?.data?.id) {
                let obj = {
                    discount: item.data.discount || 0,
                    discount2: item.data.discount2 || 0,
                    gift: item.gift || false,
                    amount: item.quantity,
                    deadline: item.deadline,
                    shippingDate: item.shippingDate,
                    selectedCurrency: item.data.currency,
                    recipe: null,
                    lineTotal: item.rowTotal,
                    linePrice: item.hasOwnProperty('unitPrice') ? item.unitPrice : item.data.price,
                    stock: {
                        id: item.data.id,
                    }
                }
                contentOfBidList.push(obj)
            }
        })

        const requestObj = {
            dateOfBid: offerDate._d,
            delivery: offerShipping,
            exchangeRate: offerCurrency,
            note: offerNote,
            payment: offerPayment,
            representative: offerCompanyOfficer,
            contentOfBidList: contentOfBidList,
            customer: {
                id: offerInfo.customer
            }

        }

        createOffer(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                setTimeout(() => window.location = '/landing/offer/list', 350)
            })
            .catch(() => exitLoadingState(setLoadings))
    }


    return (
        <React.Fragment>
            <div>
                <h3>Teklif Bilgileri</h3>
            </div>
            <Divider/>
            <div>
                <Form
                    form={form}
                    wrapperCol={{span: 10}}
                    labelCol={{span: 7}}
                    labelAlign={'left'}
                    onFinish={handleSubmit}
                >
                    <Row>
                        <Col span={11}>

                            {customerList ?

                                <Form.Item
                                    label={'Müşteri'}
                                    name={'offerCustomer'}
                                    rules={[
                                        {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                                    ]}
                                >
                                    <AutoComplete
                                        style={{minWidth: '75px'}}
                                        onChange={handleCustomerChange}
                                        filterOption={(inputValue, option) =>
                                            option.value.toLocaleUpperCase().indexOf(inputValue.toLocaleUpperCase()) !== -1
                                        }
                                    >
                                        {customers.map(({value, text}) => (
                                            <Option key={value} value={text}>{text}</Option>
                                        ))}
                                    </AutoComplete>
                                </Form.Item>

                                : <span>Yükleniyor...</span>
                            }
                            <Form.Item
                                label={'Firma Yetkilisi'}
                                name={'offerCompanyOfficer'}
                                rules={[
                                    {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                                ]}
                            >
                                <AutoComplete
                                    style={{minWidth: '75px'}}
                                    filterOption={(inputValue, option) =>
                                        option.value.toLocaleUpperCase().indexOf(inputValue.toLocaleUpperCase()) !== -1
                                    }
                                >
                                    {relevants.map(({value, text}) => {
                                        return <Option key={value} value={text}>{text}</Option>
                                    })}
                                </AutoComplete>
                            </Form.Item>


                            <Form.Item
                                label={'Teklif Tarihi'}
                                name={'offerDate'}
                                rules={[
                                    {required: true, message: 'Bu Alan Boş Bırakılamaz'}
                                ]}
                            >
                                <DatePicker format={dateFormat} placeholder={'Tarih Seçiniz'}/>
                            </Form.Item>
                            <Form.Item
                                label={'Teslimat'}
                                name={'offerShipping'}
                                initialValue={'Alıcı Ödemeli Kargo ile'}
                            >
                                <Input/>
                            </Form.Item>

                        </Col>
                        <Col span={11}>

                            <Form.Item
                                label={'Ödeme'}
                                name={'offerPayment'}
                                initialValue={'30 Gün İçinde Hesaba EFT/Havale'}
                            >
                                <Input/>
                            </Form.Item>

                            <Form.Item
                                label={'Not'}
                                name={'offerNote'}
                                initialValue={'Teklif Geçerlilik Süresi 15 Gündür'}
                            >
                                <Input/>
                            </Form.Item>

                            <Form.Item
                                label={'Kur Bilgilendirmesi'}
                                name={'offerCurrency'}
                                initialValue={'Fatura Tarihindeki TCMB Döviz Satış Kuru Baz Alınacaktır'}
                            >
                                <Input/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div style={{marginTop: '16px'}}>
                <h3>Teklif İçeriği</h3>
            </div>
            <Divider/>
            <div>
                <OfferCreateMaterial/>
            </div>
            <div>
                <Row justify={'end'}>
                    <Col span={3}>
                        <h6>Alt Toplam</h6>
                    </Col>
                    <Col span={5}>
                        {
                            Object.keys(subTotal).map(key => {
                                let total = subTotal[key].reduce((first, second) => first + second, 0)
                                if (total > 0) {
                                    return <p key={key}>{`${key}: ${new Intl.NumberFormat().format(total)}`} </p>
                                }
                            })
                        }
                    </Col>
                </Row>
            </div>
            <div>
                <Row justify={'end'}>
                    <Col span={5}>
                        <div style={{textAlign: 'right', marginTop: '16px'}}>
                            <Button
                                type={'primary'}
                                onClick={() => form.submit()}
                                loading={loadings[0]}
                            >
                                Kaydet
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}
export default OfferCreate